"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeToJSON = exports.OrderTypeFromJSONTyped = exports.OrderTypeFromJSON = exports.OrderType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var OrderType;
(function (OrderType) {
    OrderType["ORDER"] = "ORDER";
    OrderType["QUOTE"] = "QUOTE";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
function OrderTypeFromJSON(json) {
    return OrderTypeFromJSONTyped(json, false);
}
exports.OrderTypeFromJSON = OrderTypeFromJSON;
function OrderTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OrderTypeFromJSONTyped = OrderTypeFromJSONTyped;
function OrderTypeToJSON(value) {
    return value;
}
exports.OrderTypeToJSON = OrderTypeToJSON;
